import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { botMessagesApi, type BotMessage } from '@/api/bot-messages.api';

export const botMessageKeys = {
  all: ['bot-messages'] as const,
  list: () => [...botMessageKeys.all, 'list'] as const,
};

export function useBotMessages() {
  return useQuery({
    queryKey: botMessageKeys.list(),
    queryFn: () => botMessagesApi.list(),
  });
}

export function useUpdateBotMessage() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ key, body }: { key: string; body: string }) => botMessagesApi.update(key, body),
    onSuccess: (data: BotMessage[]) => {
      toast.success('Mensaje guardado');
      qc.setQueryData(botMessageKeys.list(), data);
    },
    onError: (err: Error) => toast.error(err.message || 'Error al guardar'),
  });
}

export function useResetBotMessage() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (key: string) => botMessagesApi.reset(key),
    onSuccess: (data: BotMessage[]) => {
      toast.success('Mensaje restaurado al original');
      qc.setQueryData(botMessageKeys.list(), data);
    },
    onError: (err: Error) => toast.error(err.message || 'Error al restaurar'),
  });
}
